import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDropDownBoxModule, DxDataGridModule, DxValidatorModule } from 'devextreme-angular';
import { GridSelectBoxComponent } from './grid-select-box.component';

@NgModule({
  declarations: [GridSelectBoxComponent],
  imports: [CommonModule, DxDropDownBoxModule, DxDataGridModule, DxValidatorModule],
  exports: [GridSelectBoxComponent],
})
export class GridSelectBoxModule { }
